import { Component, OnInit } from '@angular/core';
import {InsumosViewModel, OficinaComercialViewModel} from '../../../../agris/common/AgrisViewModels';
import {AgrisService} from '@services/agris-service';
import {Subscription} from 'rxjs/Subscription';
import {MdDialogRef, MdMenuTrigger, MdSnackBar} from '@angular/material';

@Component({
  selector: 'app-remitos-selector-productos-dialog',
  templateUrl: './remitos-selector-productos-dialog.component.html',
  styleUrls: ['./remitos-selector-productos-dialog.component.scss', '../../common/remitos-common-styles.scss']
})
export class RemitosSelectorProductosDialogComponent implements OnInit {

  searchTerm = '';
  loading = false;

  insumosList = [];
  sub: Subscription[] = [];
  oficina: OficinaComercialViewModel = null;
  //sucursal: SucursalComercialViewModel = null; // AAUF-2493

  //listaSucursales: SucursalComercialViewModel[] = []; // AAUF-2493

  insumosSelected = [];

  constructor(
    public agrisService: AgrisService,
    private dialogRef: MdDialogRef<RemitosSelectorProductosDialogComponent>,
    private snackBar: MdSnackBar
  ) {
    // oficina
    this.sub.push(
      agrisService.oficina$.subscribe(x => {
        this.oficina = x;
        // this.loadSucursales(false); // AAUF-2493
      })
    );

    // sucursal
    /*
    this.sub.push(
      agrisService.sucursal$.subscribe(x => {
        this.sucursal = x;
      })
    );
    */
  }

  ngOnInit() {
  }

  public loadOldProductos(productos) {
    this.insumosSelected = productos;
  }

  // region Insumos
  onSearch(menuTrigger: MdMenuTrigger) {
    if (!this.searchTerm.length) {return;}
    // if (this.oficina === null || this.sucursal === null) {
    //   this.snackBar.open('Ha ocurrido un error al obtener la busqueda, por favor intente nuevamente', null, {duration: 3000});
    //   return;
    // }
    menuTrigger.closeMenu();
    this.insumosList = [];
    const payload: InsumosViewModel = {
      IdOficina: this.oficina.Id,
      IdSucursal: this.oficina.Id, // AAUF-2493: Se envía el ID de la oficina de forma predeterminada
      filter: this.searchTerm,
      filterFamilia: '',
      filterLinea: '',
      filterRubro: '',
      filterSubRubro: '',
      listaInsumos: []
    };
    this.loading = true;
    const sub = this.agrisService.searchInsumos(payload).subscribe(x => {
      this.insumosList = x !== null ? x.listaInsumos.map(x => ({...x, selected: false, multiploError: false, cantidad: x.Multiplo})) : [];
      this.loading = false;
      this.openMenu(menuTrigger);
      sub.unsubscribe();
    }, () => {
      this.loading = false;
      this.agrisService.showSnackbarAPIError();
      sub.unsubscribe();
    });

  }

  onSubmit() {
    // verificamos que haya insumos seleccionados y que el valor cantidad sea correcto
    if (this.insumosSelected.length < 1) {
      this.snackBar.open('Debe seleccionar al menos un producto', null, {duration: 3000});
      return;
    }
    if (this.insumosSelected.some(x => x.cantidad < 1 || x.cantidad.toString().length === 0 || x.multiploError)) {
      this.snackBar.open('Debe completar correctamente el campo cantidad en todos los productos', null, {duration: 3000});
      return;
    }
    this.dialogRef.close(this.insumosSelected);
  }

  selectedProducto(e, producto) {
    // verificamos que el insumo no esté en la lista
    if (!this.insumosSelected.some(x => x.Nombre === producto.Nombre)) {
      // lo añadimos
      this.insumosSelected.push({...producto});
    }
  }

  removeItem(index) {
    this.insumosSelected.splice(index, 1);
  }

  openMenu(menuTrigger: MdMenuTrigger) {
    if (this.insumosList.length) {
      menuTrigger.openMenu();
    }
  }

  checkMultiplo(item, e) {
    if (e !== null) {
      item.multiploError = e % item.Multiplo !== 0;
    }
  }

  // endregion

  // region Oficina Sucursal
  /*
  loadSucursales(setDefault = true): void {
    if (this.oficina !== null) {
      this.agrisService.getSucursales(this.oficina.Id).subscribe(y => {
        this.listaSucursales = y;
        if (setDefault) {
          this.sucursal = this.listaSucursales[0];
        }
      });
    }
  }
  */

  onSelectedOficina(ofi: OficinaComercialViewModel) {
    this.oficina = ofi;
    // this.loadSucursales() // AAUF-2493: No se necesita enviar el ID de sucursal
  }

  // endregion

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/administracion/remitos/remitos-generar-page/remitos-selector-productos-dialog/remitos-selector-productos-dialog.component.ts